import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import Cookies from "universal-cookie";
import NotAllowed from '../pages/errors/NotAllowed'
import { ROLE, ROLES, TOKEN_NAME } from '../config';
import { useOnboardingContext } from "../context/OnboardingContext";
import { isOnboardingPathAllowed } from "./accessPolicy";
import PrimaryLoader from "../components/common/PrimaryLoader";

const cookies = new Cookies();


function ProtectedRoutes({ allowedRoles, ...restOfProps }) {
    const location = useLocation();
    let token = cookies.get(TOKEN_NAME);
    let role = cookies.get(ROLE);
    const { companyCompletionStatus, isCheckingAccess } = useOnboardingContext();

    if (!token) {
        return <Navigate to="/" replace />;
    }

    if (isCheckingAccess) {
        return (
            <div className="flex justify-center items-center min-h-screen bg-[#f9fafb]">
                <PrimaryLoader />
            </div>
        );
    }

    const isAdmin = role === ROLES.COMPANY_ADMIN;

    // Handle incomplete onboarding
    if (companyCompletionStatus !== true) {
        if (isAdmin) {
            const isOnboardingRoute = isOnboardingPathAllowed(location.pathname, role);
            if (!isOnboardingRoute) {
                const isDefaultLanding = location.pathname === "/";
                return <Navigate to={isDefaultLanding ? "/onboarding" : "/onboarding?restricted=true"} replace />;
            }
        } else {
            // Employees/consultants are strictly restricted to /onboarding until company onboarding is completed
            if (location.pathname !== "/onboarding") {
                const isDefaultLanding = location.pathname === "/";
                return <Navigate to={isDefaultLanding ? "/onboarding" : "/onboarding?restricted=true"} replace />;
            }
        }
    }

    // Role-based Access Control (RBAC) check when onboarding is complete
    if (allowedRoles && allowedRoles.length > 0) {
        if (!allowedRoles.includes(role)) {
            return <NotAllowed />;
        }
    }

    return <Outlet />;
}

export default ProtectedRoutes;